import { useRMSelector } from 'redux/hooks';
import { BackgroundJobDTO } from 'components/backgroundjobs/backgroundJobs';
import { EJobStatus } from 'business/models/CustomModels';
import { JobTypeDTO } from 'components/main/Setup/Imaging/ImageManagementTask/constants';

export const useGetBackgroundJobs = () => {
  return useRMSelector((state) => state.backgroundJobs.backgroundJobs);
};

const isActiveArchivingJob = (job: BackgroundJobDTO) =>
  job.jobStatus === EJobStatus.InProgress;

export const useSelectArchivingBackgroundJob = () => {
  return useRMSelector((state) => {
    const archivingJobs = state.backgroundJobs.backgroundJobs.filter(
      (job) => Number(job.jobType) === JobTypeDTO.Archiving,
    );

    if (archivingJobs.length === 0) {
      return null;
    }

    return (
      archivingJobs.find(isActiveArchivingJob) ?? archivingJobs[archivingJobs.length - 1]
    );
  });
};

export const useSelectUnarchivingBackgroundJob = () => {
  return useRMSelector((state) => {
    const unarchivingJobs = state.backgroundJobs.backgroundJobs.filter(
      (job) => Number(job.jobType) === JobTypeDTO.Unarchive,
    );

    if (unarchivingJobs.length === 0) {
      return null;
    }

    return (
      unarchivingJobs.find(isActiveArchivingJob) ??
      unarchivingJobs[unarchivingJobs.length - 1]
    );
  });
};
